module.exports = __webpack_public_path__ + "static/img/sence-5-map.ebdfbd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-5-map.png
// module id = VTzl
// module chunks = 1